module.exports = __webpack_public_path__ + "static/img/banner.87d9e2e1.png";